import { Line } from 'react-chartjs-2'
import Chart from 'chart.js/auto';

function LineChart() {
    return (
        <Line
            data={{
                labels: ["11/07", "12/07", "13/07", "14/07", "15/07", "16/07", "17/07"],
                datasets: [
                    {
                        label: "Doanh thu",
                        data: [10, 20, 30, 42, 51, 82, 31],
                        backgroundColor: '#ff6801',
                        borderColor: 'green',
                        tension: 0.4,
                        fill: true,
                        pointStyle: 'rect',
                        pointBorderColor: 'blue',
                        pointBackgroundColor: '#fff',
                        showLine: true
                    }
                ]
            }}
            option={{
                title: {
                    display: false,
                    text: "Predicted world population (millions) in 2050"
                }
            }}
        />
    );
}

export default LineChart;